import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import { authConfig } from "./authConfig";

const store = configureStore();
const config = authConfig();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Auth0Provider
        // clientSecret={config.clientSecret}
        issuer={config.issuer}
        domain={config.domain}
        clientId={config.clientId}
        audience={config.audience}
        redirectUri={config.redirectUri}
        scope={config.scope}
      >
        <App />
      </Auth0Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();

